import React, { Component } from "react";
import moment from "moment";
import { Container } from "reactstrap";

import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import accountInfoActions from "../../redux/accountInfo/action";
import "./style.css";
import { connect } from "react-redux";
import PageHead from "../../component/pageHead/PageHead";
import { Table } from "reactstrap";
import api from "../../config/api";
import {
  formatNumbers,
  isNetworkRequestFailedError,
} from "../../config/helpers";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
class CurrentBalance extends Component {
  state = {
    data: [],
    isLoading: false,
  };

  componentDidMount() {
    const { history, setHistory, currentBalance, user } = this.props;
    setHistory(history);

    if (!currentBalance && user) {
      this.fetchingData();
    }
  }

  fetchingData = async () => {
    this.setState({ isLoading: true });

    const { user, setAlertMessage, setCurrentBalanceValues } = this.props;
    const endDate = moment().format("YYYY-MMMM-DD");
    const payload = {
      pin: user.profile.pin,
      endDate,
    };
    const memberBalance = api.fetchMemberBalance(payload, user.token);
    const allData = api.allMemberBalance(payload, user.token);

    try {
      const data = await Promise.all([memberBalance, allData]);

      const balances = {
        ManBal: data[1].data.result[0].ManBal,
        VolBal: data[1].data.result[0].VolBal,
        rsaBal: data[0].data.result,
      };

      setCurrentBalanceValues(balances);
      this.setState({ data: balances });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchingData : null,
      });
    }
    this.setState({ isLoading: false });
  };

  render() {
    const { isLoading } = this.state;
    const { currentBalance: data } = this.props;

    return (
      <Container>
        <PageHead title="CURRENT BALANCE" containerStyles={{ width: "100%" }} />
        {data && !!Object.keys(data).length && (
          <Table borderless className="current-balance-table">
            <tbody>
              <tr className="second-row">
                <th scope="row">RSA Balance</th>
                <td>₦ {formatNumbers(data.rsaBal)}</td>
              </tr>
              <tr className="second-row">
                <th scope="row">Mandatory Contribution Balance</th>
                <td>₦ {formatNumbers(data.ManBal)}</td>
              </tr>
              <tr className="second-row">
                <th scope="row">Voluntary Contribution Balance</th>
                <td>₦ {formatNumbers(data.VolBal)}</td>
              </tr>
            </tbody>
          </Table>
        )}
        {isLoading && <CustomLoader />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  currentBalance: state.accountInfo.currentBalance,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
  setCurrentBalanceValues: accountInfoActions.setCurrentBalanceValues,
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentBalance);
